/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: EiGvDP89iw_p

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import InfoSection from "../../InfoSection"; // plasmic-import: 0gf8lKLu2jNB/component
import { RawUl } from "@fullstackhouse/plasmic-utils/dist/code-components/RawList/Ul"; // plasmic-import: MgrwvgDVmmr8/codeComponent
import { RawLi } from "@fullstackhouse/plasmic-utils/dist/code-components/RawList/Li"; // plasmic-import: AzSSlTj_Nw6K/codeComponent

import { useScreenVariants as useScreenVariantsgibwEjXEmhF1 } from "./PlasmicGlobalVariant__Mobile"; // plasmic-import: GIBWEjXEmhF1/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicPrivacyPolicyBanner.module.css"; // plasmic-import: EiGvDP89iw_p/css

createPlasmicElementProxy;

export type PlasmicPrivacyPolicyBanner__VariantMembers = {};
export type PlasmicPrivacyPolicyBanner__VariantsArgs = {};
type VariantPropType = keyof PlasmicPrivacyPolicyBanner__VariantsArgs;
export const PlasmicPrivacyPolicyBanner__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPrivacyPolicyBanner__ArgsType = {};
type ArgPropType = keyof PlasmicPrivacyPolicyBanner__ArgsType;
export const PlasmicPrivacyPolicyBanner__ArgProps = new Array<ArgPropType>();

export type PlasmicPrivacyPolicyBanner__OverridesType = {
  banner?: Flex__<"div">;
  container?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  heading?: Flex__<"div">;
  title?: Flex__<"h1">;
  subtitle?: Flex__<"h4">;
  contentRow?: Flex__<"div">;
  contentColumn?: Flex__<"div">;
  ourSoc2TypeIiCertification?: Flex__<typeof InfoSection>;
  informationWeCollect?: Flex__<typeof InfoSection>;
  h3?: Flex__<"h3">;
  anonymousAndNonAnonymousEvaluations?: Flex__<typeof InfoSection>;
  howWeUseYourInformation?: Flex__<typeof InfoSection>;
  geolocationAndMyQuickPassTracking?: Flex__<typeof InfoSection>;
  dataPrivacyAndThirdParties?: Flex__<typeof InfoSection>;
  accessAndControlOfPersonalData?: Flex__<typeof InfoSection>;
  yourRightsAndChoices?: Flex__<typeof InfoSection>;
  securityMeasures?: Flex__<typeof InfoSection>;
  regulatoryCompliance?: Flex__<typeof InfoSection>;
  cookiesAndTracking?: Flex__<typeof InfoSection>;
  changesToThisPolicy?: Flex__<typeof InfoSection>;
  contactUs?: Flex__<typeof InfoSection>;
  line?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultPrivacyPolicyBannerProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicPrivacyPolicyBanner__RenderFunc(props: {
  variants: PlasmicPrivacyPolicyBanner__VariantsArgs;
  args: PlasmicPrivacyPolicyBanner__ArgsType;
  overrides: PlasmicPrivacyPolicyBanner__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = ensureGlobalVariants({
    mobile: useScreenVariantsgibwEjXEmhF1()
  });

  return (
    <div
      data-plasmic-name={"banner"}
      data-plasmic-override={overrides.banner}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.banner
      )}
    >
      <Stack__
        as={"section"}
        data-plasmic-name={"container"}
        data-plasmic-override={overrides.container}
        hasGap={true}
        className={classNames(projectcss.all, sty.container)}
      >
        <Stack__
          as={"div"}
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          hasGap={true}
          className={classNames(projectcss.all, sty.wrapper)}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"heading"}
            data-plasmic-override={overrides.heading}
            hasGap={true}
            className={classNames(projectcss.all, sty.heading)}
          >
            <h1
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.h1,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Privacy Policy"}
            </h1>
            <h4
              data-plasmic-name={"subtitle"}
              data-plasmic-override={overrides.subtitle}
              className={classNames(
                projectcss.all,
                projectcss.h4,
                projectcss.__wab_text,
                sty.subtitle
              )}
            >
              {"Effective Date: January 8, 2025"}
            </h4>
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"contentRow"}
            data-plasmic-override={overrides.contentRow}
            hasGap={true}
            className={classNames(projectcss.all, sty.contentRow)}
          >
            <Stack__
              as={"div"}
              data-plasmic-name={"contentColumn"}
              data-plasmic-override={overrides.contentColumn}
              hasGap={true}
              className={classNames(projectcss.all, sty.contentColumn)}
            >
              <p
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.p__uc916
                )}
              >
                {
                  "This privacy policy applies to https://www.myevaluations.com, owned and operated by MyEvaluations.com. It describes how MyEvaluations.com collects, uses, and protects personal information you provide on our website and services. The use of information collected through our services is limited to providing the services for which our clients engage MyEvaluations.com. This policy also outlines your choices regarding the collection, use, and access to your personal information.\n\nMyEvaluations.com is committed to protecting your privacy and adheres to the highest standards of accountability and transparency. Our systems use the latest technologies, including SSL encryption and SecurityMetrics compliance, to safeguard your data."
                }
              </p>
              <InfoSection
                data-plasmic-name={"ourSoc2TypeIiCertification"}
                data-plasmic-override={overrides.ourSoc2TypeIiCertification}
                className={classNames(
                  "__wab_instance",
                  sty.ourSoc2TypeIiCertification
                )}
                content={
                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__q9ANb
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>
                        {
                          "As part of our commitment to data security, MyEvaluations.com has achieved "
                        }
                      </React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700 }}
                      >
                        {"SOC 2 Type II Certification"}
                      </span>
                      <React.Fragment>
                        {
                          ", which independently verifies that our systems, processes, and controls meet rigorous standards for security, availability, and confidentiality. This certification complements our already robust security practices, ensuring our platform remains a secure environment for sensitive data."
                        }
                      </React.Fragment>
                    </React.Fragment>
                  </p>
                }
                heading={"Our SOC 2 Type II Certification"}
              />

              <InfoSection
                data-plasmic-name={"informationWeCollect"}
                data-plasmic-override={overrides.informationWeCollect}
                className={classNames(
                  "__wab_instance",
                  sty.informationWeCollect
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__oZ5Oq
                      )}
                    >
                      {"We collect the following types of information:"}
                    </p>
                    <h3
                      data-plasmic-name={"h3"}
                      data-plasmic-override={overrides.h3}
                      className={classNames(
                        projectcss.all,
                        projectcss.h3,
                        projectcss.__wab_text,
                        sty.h3
                      )}
                    >
                      {"Personal Information"}
                    </h3>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__xeAyj)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__qvGz
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__t2Nm
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"From Demo Requests:"}
                            </span>
                            <React.Fragment>
                              {" Name, email address, and phone number."}
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__lrGa
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__hp4Kh
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"From Institutions:"}
                            </span>
                            <React.Fragment>
                              {
                                " Data provided by your institution, including your username (e.g., first initial and last name) and responses to evaluation questions."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__eTgtV
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__pyEq6
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"From Users:"}
                            </span>
                            <React.Fragment>
                              {
                                " Information entered into specific features such as Procedure and Patient Log Tracking Modules, which may include patient names, medical record numbers, diagnoses, and procedural data."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Information We Collect"}
              />

              <InfoSection
                data-plasmic-name={"anonymousAndNonAnonymousEvaluations"}
                data-plasmic-override={
                  overrides.anonymousAndNonAnonymousEvaluations
                }
                className={classNames(
                  "__wab_instance",
                  sty.anonymousAndNonAnonymousEvaluations
                )}
                content={
                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__jsSgM
                    )}
                  >
                    {
                      "Some evaluations (e.g., resident-of-attending or nurse-of-resident) are anonymous, while others (e.g., attending-of-resident evaluations) are not. Anonymous data is reported to the sponsoring institution without identifying the evaluator."
                    }
                  </p>
                }
                heading={"Anonymous and Non-Anonymous Evaluations"}
              />

              <InfoSection
                data-plasmic-name={"howWeUseYourInformation"}
                data-plasmic-override={overrides.howWeUseYourInformation}
                className={classNames(
                  "__wab_instance",
                  sty.howWeUseYourInformation
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__xwJcY
                      )}
                    >
                      {"We use the information we collect to:"}
                    </p>
                    <RawUl
                      className={classNames(
                        "__wab_instance",
                        sty.rawUl___4R8VD
                      )}
                    >
                      {(_par =>
                        !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                        (() => {
                          try {
                            return [
                              "Provide and manage the services you or your sponsoring institution have engaged.",
                              "Generate reports and track compliance with training and clinical requirements.",
                              "Improve our services by monitoring traffic patterns and user interactions.",
                              "Ensure security and compliance through geolocation-based tracking in features like MyQuickPass (optional, with explicit consent)."
                            ];
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return [];
                            }
                            throw e;
                          }
                        })()
                      ).map((__plasmic_item_0, __plasmic_idx_0) => {
                        const currentItem = __plasmic_item_0;
                        const currentIndex = __plasmic_idx_0;
                        return (
                          <RawLi
                            className={classNames(
                              "__wab_instance",
                              sty.rawLi__uOmDa
                            )}
                            key={currentIndex}
                          >
                            <p
                              className={classNames(
                                projectcss.all,
                                projectcss.p,
                                projectcss.__wab_text,
                                sty.p___7Tyfp
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return currentItem;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </p>
                          </RawLi>
                        );
                      })}
                    </RawUl>
                  </React.Fragment>
                }
                heading={"How We Use Your Information"}
              />

              <InfoSection
                data-plasmic-name={"geolocationAndMyQuickPassTracking"}
                data-plasmic-override={
                  overrides.geolocationAndMyQuickPassTracking
                }
                className={classNames(
                  "__wab_instance",
                  sty.geolocationAndMyQuickPassTracking
                )}
                content={
                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__ogTdN
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{"The optional "}</React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700 }}
                      >
                        {"MyQuickPass "}
                      </span>
                      <React.Fragment>
                        {
                          "service leverages geofence technology to track clinical hours without continuous location monitoring. The service records entry and exit times from predefined locations set by your institution. Data is stored securely and used solely for compliance tracking. Users provide explicit consent for this service and can review or edit their tracked hours."
                        }
                      </React.Fragment>
                    </React.Fragment>
                  </p>
                }
                heading={"Geolocation and MyQuickPass Tracking"}
              />

              <InfoSection
                data-plasmic-name={"dataPrivacyAndThirdParties"}
                data-plasmic-override={overrides.dataPrivacyAndThirdParties}
                className={classNames(
                  "__wab_instance",
                  sty.dataPrivacyAndThirdParties
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p___6REPg
                      )}
                    >
                      {
                        "We partner with HIPAA- and HITECH-compliant third-party database providers to store and process data securely. These providers follow our strict data privacy standards and are not permitted to use your data for any other purposes. No geolocation data or personal information is shared with third parties without user or institutional authorization."
                      }
                    </p>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p___6Csug
                      )}
                    >
                      {
                        "In certain circumstances, we may be legally required to disclose personal data in response to lawful requests by public authorities, including those related to national security or law enforcement. Additionally, we may disclose your personal information to comply with subpoenas or other legal processes, or when we believe in good faith that such disclosure is necessary to protect our rights, ensure your safety or the safety of others, investigate fraud, or respond to a government request."
                      }
                    </p>
                  </React.Fragment>
                }
                heading={"Data Privacy and Third Parties"}
              />

              <InfoSection
                data-plasmic-name={"accessAndControlOfPersonalData"}
                data-plasmic-override={overrides.accessAndControlOfPersonalData}
                className={classNames(
                  "__wab_instance",
                  sty.accessAndControlOfPersonalData
                )}
                content={
                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p___8MsZx
                    )}
                  >
                    {
                      "You can access, correct, update, or delete your personal data by contacting your institution's administrator or MyEvaluations.com directly. Requests are processed within 30 business days."
                    }
                  </p>
                }
                heading={"Access and Control of Personal Data"}
              />

              <InfoSection
                data-plasmic-name={"yourRightsAndChoices"}
                data-plasmic-override={overrides.yourRightsAndChoices}
                className={classNames(
                  "__wab_instance",
                  sty.yourRightsAndChoices
                )}
                content={
                  <RawUl
                    className={classNames("__wab_instance", sty.rawUl__j2L8V)}
                  >
                    <RawLi
                      className={classNames("__wab_instance", sty.rawLi__q4DAs)}
                    >
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__rxOgS
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"Opt-Out of Marketing Communications:"}
                          </span>
                          <React.Fragment>
                            {
                              " You may unsubscribe from marketing emails by following the instructions provided in the email or contacting us at "
                            }
                          </React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link___4ORdm
                              )}
                              component={Link}
                              href={"mailto:sales@myevaluations.com"}
                              platform={"nextjs"}
                            >
                              {"Sales@MyEvaluations.com"}
                            </PlasmicLink__>
                          }
                          <React.Fragment>{"."}</React.Fragment>
                        </React.Fragment>
                      </p>
                    </RawLi>
                    <RawLi
                      className={classNames("__wab_instance", sty.rawLi__jtLhD)}
                    >
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__lkPm
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"Data Retention:"}
                          </span>
                          <React.Fragment>
                            {
                              " We retain personal information as long as necessary to provide services or comply with legal obligations. Users may request data deletion by contacting their institution or MyEvaluations.com."
                            }
                          </React.Fragment>
                        </React.Fragment>
                      </p>
                    </RawLi>
                  </RawUl>
                }
                heading={"Your Rights and Choices"}
              />

              <InfoSection
                data-plasmic-name={"securityMeasures"}
                data-plasmic-override={overrides.securityMeasures}
                className={classNames("__wab_instance", sty.securityMeasures)}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__yhgR7
                      )}
                    >
                      {
                        "MyEvaluations.com implements robust security measures to protect your data:"
                      }
                    </p>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__qF9Ib)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__mJ84M
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__eqWby
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Encryption:"}
                            </span>
                            <React.Fragment>
                              {
                                " All data is encrypted in transit (TLS 1.2+) and at rest (AES-256)."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__qhyLs
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__o4Q8Z
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Regular Audits:"}
                            </span>
                            <React.Fragment>
                              {
                                " Routine internal and external security audits ensure compliance and identify vulnerabilities."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__aG5F
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__okMcd
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Access Controls:"}
                            </span>
                            <React.Fragment>
                              {
                                " Role-based access limits data availability to authorized personnel."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Security Measures"}
              />

              <InfoSection
                data-plasmic-name={"regulatoryCompliance"}
                data-plasmic-override={overrides.regulatoryCompliance}
                className={classNames(
                  "__wab_instance",
                  sty.regulatoryCompliance
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__pbgFv
                      )}
                    >
                      {
                        "MyEvaluations.com complies with the following regulations:"
                      }
                    </p>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl___8Pp1)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__jb2L
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__kteX5
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"SOC 2 Type II Certification:"}
                            </span>
                            <React.Fragment>
                              {
                                " Independent validation of our operational and security controls."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__xu481
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__foxbT
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"HIPAA Compliance: "}
                            </span>
                            <React.Fragment>
                              {
                                "Ensures the confidentiality of protected health information (PHI)."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi___8LHmo
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__gspY
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"GDPR Compliance:"}
                            </span>
                            <React.Fragment>
                              {
                                " Adheres to EU standards for data transparency and control."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__nyphB
                        )}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__tgibg
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"FERPA Compliance: "}
                            </span>
                            <React.Fragment>
                              {
                                "Protects the confidentiality of student records."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Regulatory Compliance"}
              />

              <InfoSection
                data-plasmic-name={"cookiesAndTracking"}
                data-plasmic-override={overrides.cookiesAndTracking}
                className={classNames("__wab_instance", sty.cookiesAndTracking)}
                content={
                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__yFcIp
                    )}
                  >
                    {
                      "We use cookies and similar technologies to improve user experience and analyze trends. You can disable cookies through your browser settings, though some features may become unavailable."
                    }
                  </p>
                }
                heading={"Cookies and Tracking"}
              />

              <InfoSection
                data-plasmic-name={"changesToThisPolicy"}
                data-plasmic-override={overrides.changesToThisPolicy}
                className={classNames(
                  "__wab_instance",
                  sty.changesToThisPolicy
                )}
                content={
                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__eUucT
                    )}
                  >
                    {
                      "We may update this privacy policy to reflect changes to our practices. Users will be notified via email or a notice on our website before updates take effect. We encourage you to review this page periodically."
                    }
                  </p>
                }
                heading={"Changes to This Policy"}
              />

              <InfoSection
                data-plasmic-name={"contactUs"}
                data-plasmic-override={overrides.contactUs}
                className={classNames("__wab_instance", sty.contactUs)}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__eVcxm
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>
                          {
                            "For privacy concerns or additional information, please contact us:\n"
                          }
                        </React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"Email:"}
                        </span>
                        <React.Fragment>
                          {" Sales@MyEvaluations.com\n"}
                        </React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"Phone:"}
                        </span>
                        <React.Fragment>{" (866) 422-0554\n"}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"Address: "}
                        </span>
                        <React.Fragment>
                          {"1159 Second Avenue, Suite 226, New York, NY 10065"}
                        </React.Fragment>
                      </React.Fragment>
                    </p>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__nn3Ko
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>
                          {
                            "If you have any unresolved concerns regarding privacy or data usage that we have not satisfactorily addressed, please contact our U.S.-based, third-party dispute resolution provider free of charge at:\r\n"
                          }
                        </React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              projectcss.all,
                              projectcss.a,
                              projectcss.__wab_text,
                              projectcss.plasmic_default__inline,
                              sty.link__eUg5S
                            )}
                            component={Link}
                            href={
                              "https://feedback-form.truste.com/watchdog/request"
                            }
                            platform={"nextjs"}
                            target={"_blank"}
                          >
                            {
                              "https://feedback-form.truste.com/watchdog/request"
                            }
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    </p>
                  </React.Fragment>
                }
                heading={"Contact Us"}
              />
            </Stack__>
          </Stack__>
          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? false
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? true
              : true
          ) ? (
            <PlasmicImg__
              data-plasmic-name={"line"}
              data-plasmic-override={overrides.line}
              alt={""}
              className={classNames(sty.line)}
              displayHeight={"1067.99px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={
                hasVariant(globalVariants, "mobile", "tabletPortrait")
                  ? "895px"
                  : "auto"
              }
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/f8c2846a1d939511f6aa136587f7afe2.svg",
                fullWidth: 895,
                fullHeight: 1068,
                aspectRatio: 0.838015
              }}
            />
          ) : null}
        </Stack__>
      </Stack__>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  banner: [
    "banner",
    "container",
    "wrapper",
    "heading",
    "title",
    "subtitle",
    "contentRow",
    "contentColumn",
    "ourSoc2TypeIiCertification",
    "informationWeCollect",
    "h3",
    "anonymousAndNonAnonymousEvaluations",
    "howWeUseYourInformation",
    "geolocationAndMyQuickPassTracking",
    "dataPrivacyAndThirdParties",
    "accessAndControlOfPersonalData",
    "yourRightsAndChoices",
    "securityMeasures",
    "regulatoryCompliance",
    "cookiesAndTracking",
    "changesToThisPolicy",
    "contactUs",
    "line"
  ],
  container: [
    "container",
    "wrapper",
    "heading",
    "title",
    "subtitle",
    "contentRow",
    "contentColumn",
    "ourSoc2TypeIiCertification",
    "informationWeCollect",
    "h3",
    "anonymousAndNonAnonymousEvaluations",
    "howWeUseYourInformation",
    "geolocationAndMyQuickPassTracking",
    "dataPrivacyAndThirdParties",
    "accessAndControlOfPersonalData",
    "yourRightsAndChoices",
    "securityMeasures",
    "regulatoryCompliance",
    "cookiesAndTracking",
    "changesToThisPolicy",
    "contactUs",
    "line"
  ],
  wrapper: [
    "wrapper",
    "heading",
    "title",
    "subtitle",
    "contentRow",
    "contentColumn",
    "ourSoc2TypeIiCertification",
    "informationWeCollect",
    "h3",
    "anonymousAndNonAnonymousEvaluations",
    "howWeUseYourInformation",
    "geolocationAndMyQuickPassTracking",
    "dataPrivacyAndThirdParties",
    "accessAndControlOfPersonalData",
    "yourRightsAndChoices",
    "securityMeasures",
    "regulatoryCompliance",
    "cookiesAndTracking",
    "changesToThisPolicy",
    "contactUs",
    "line"
  ],
  heading: ["heading", "title", "subtitle"],
  title: ["title"],
  subtitle: ["subtitle"],
  contentRow: [
    "contentRow",
    "contentColumn",
    "ourSoc2TypeIiCertification",
    "informationWeCollect",
    "h3",
    "anonymousAndNonAnonymousEvaluations",
    "howWeUseYourInformation",
    "geolocationAndMyQuickPassTracking",
    "dataPrivacyAndThirdParties",
    "accessAndControlOfPersonalData",
    "yourRightsAndChoices",
    "securityMeasures",
    "regulatoryCompliance",
    "cookiesAndTracking",
    "changesToThisPolicy",
    "contactUs"
  ],
  contentColumn: [
    "contentColumn",
    "ourSoc2TypeIiCertification",
    "informationWeCollect",
    "h3",
    "anonymousAndNonAnonymousEvaluations",
    "howWeUseYourInformation",
    "geolocationAndMyQuickPassTracking",
    "dataPrivacyAndThirdParties",
    "accessAndControlOfPersonalData",
    "yourRightsAndChoices",
    "securityMeasures",
    "regulatoryCompliance",
    "cookiesAndTracking",
    "changesToThisPolicy",
    "contactUs"
  ],
  ourSoc2TypeIiCertification: ["ourSoc2TypeIiCertification"],
  informationWeCollect: ["informationWeCollect", "h3"],
  h3: ["h3"],
  anonymousAndNonAnonymousEvaluations: ["anonymousAndNonAnonymousEvaluations"],
  howWeUseYourInformation: ["howWeUseYourInformation"],
  geolocationAndMyQuickPassTracking: ["geolocationAndMyQuickPassTracking"],
  dataPrivacyAndThirdParties: ["dataPrivacyAndThirdParties"],
  accessAndControlOfPersonalData: ["accessAndControlOfPersonalData"],
  yourRightsAndChoices: ["yourRightsAndChoices"],
  securityMeasures: ["securityMeasures"],
  regulatoryCompliance: ["regulatoryCompliance"],
  cookiesAndTracking: ["cookiesAndTracking"],
  changesToThisPolicy: ["changesToThisPolicy"],
  contactUs: ["contactUs"],
  line: ["line"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  banner: "div";
  container: "section";
  wrapper: "div";
  heading: "div";
  title: "h1";
  subtitle: "h4";
  contentRow: "div";
  contentColumn: "div";
  ourSoc2TypeIiCertification: typeof InfoSection;
  informationWeCollect: typeof InfoSection;
  h3: "h3";
  anonymousAndNonAnonymousEvaluations: typeof InfoSection;
  howWeUseYourInformation: typeof InfoSection;
  geolocationAndMyQuickPassTracking: typeof InfoSection;
  dataPrivacyAndThirdParties: typeof InfoSection;
  accessAndControlOfPersonalData: typeof InfoSection;
  yourRightsAndChoices: typeof InfoSection;
  securityMeasures: typeof InfoSection;
  regulatoryCompliance: typeof InfoSection;
  cookiesAndTracking: typeof InfoSection;
  changesToThisPolicy: typeof InfoSection;
  contactUs: typeof InfoSection;
  line: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPrivacyPolicyBanner__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPrivacyPolicyBanner__VariantsArgs;
    args?: PlasmicPrivacyPolicyBanner__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicPrivacyPolicyBanner__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicPrivacyPolicyBanner__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPrivacyPolicyBanner__ArgProps,
          internalVariantPropNames: PlasmicPrivacyPolicyBanner__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPrivacyPolicyBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "banner") {
    func.displayName = "PlasmicPrivacyPolicyBanner";
  } else {
    func.displayName = `PlasmicPrivacyPolicyBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicPrivacyPolicyBanner = Object.assign(
  // Top-level PlasmicPrivacyPolicyBanner renders the root element
  makeNodeComponent("banner"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    wrapper: makeNodeComponent("wrapper"),
    heading: makeNodeComponent("heading"),
    title: makeNodeComponent("title"),
    subtitle: makeNodeComponent("subtitle"),
    contentRow: makeNodeComponent("contentRow"),
    contentColumn: makeNodeComponent("contentColumn"),
    ourSoc2TypeIiCertification: makeNodeComponent("ourSoc2TypeIiCertification"),
    informationWeCollect: makeNodeComponent("informationWeCollect"),
    h3: makeNodeComponent("h3"),
    anonymousAndNonAnonymousEvaluations: makeNodeComponent(
      "anonymousAndNonAnonymousEvaluations"
    ),
    howWeUseYourInformation: makeNodeComponent("howWeUseYourInformation"),
    geolocationAndMyQuickPassTracking: makeNodeComponent(
      "geolocationAndMyQuickPassTracking"
    ),
    dataPrivacyAndThirdParties: makeNodeComponent("dataPrivacyAndThirdParties"),
    accessAndControlOfPersonalData: makeNodeComponent(
      "accessAndControlOfPersonalData"
    ),
    yourRightsAndChoices: makeNodeComponent("yourRightsAndChoices"),
    securityMeasures: makeNodeComponent("securityMeasures"),
    regulatoryCompliance: makeNodeComponent("regulatoryCompliance"),
    cookiesAndTracking: makeNodeComponent("cookiesAndTracking"),
    changesToThisPolicy: makeNodeComponent("changesToThisPolicy"),
    contactUs: makeNodeComponent("contactUs"),
    line: makeNodeComponent("line"),

    // Metadata about props expected for PlasmicPrivacyPolicyBanner
    internalVariantProps: PlasmicPrivacyPolicyBanner__VariantProps,
    internalArgProps: PlasmicPrivacyPolicyBanner__ArgProps
  }
);

export default PlasmicPrivacyPolicyBanner;
/* prettier-ignore-end */
